export const requestInterceptor = (config) => {
    const token = localStorage.getItem('KEY_ACCESS_TOKEN');
    config.headers.Authorization = `Bearer ${token}`;
    return config;
}
